import { render, staticRenderFns } from "./LampBleConfigDetails.vue?vue&type=template&id=66667218&"
import script from "./LampBleConfigDetails.vue?vue&type=script&lang=js&"
export * from "./LampBleConfigDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports